import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { SERVICES } from "../../lib/site";
import { Eyebrow, Reveal } from "./Motion";

const pick = (id) => SERVICES.find((s) => s.id === id);
const SMALL = ["tarot-card-reading", "psychic-reading", "love-relationship-guidance", "career-business-guidance", "spiritual-healing"].map(pick);

const Tile = ({ s, i, className = "" }) => {
  const Icon = s.icon;
  return (
    <motion.div initial={{ opacity: 0, y: 30 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true, amount: 0.15 }}
      transition={{ duration: 0.8, delay: i * 0.06 }} className={className}>
      <Link to={`/book?service=${s.id}`} data-testid={`bento-service-${s.id}`}
        className="group relative flex h-full min-h-[240px] flex-col justify-between overflow-hidden border border-[#D4AF37]/15 bg-[#0E081D] p-7 transition-[border-color] duration-500 hover:border-[#D4AF37]/50">
        <img src={s.image} alt="" loading="lazy" className="absolute inset-0 h-full w-full object-cover opacity-90 brightness-125 saturate-125 transition-transform duration-1000 group-hover:scale-105" />
        <div className="absolute inset-0 bg-gradient-to-t from-[#0E081D]/95 via-[#0E081D]/30 to-transparent" />
        <div className="relative flex items-center justify-between">
          <Icon className="h-6 w-6 text-[#D4AF37]" strokeWidth={1.3} />
          <ArrowUpRight className="h-5 w-5 text-slate-400 transition-[transform,color] duration-500 group-hover:rotate-45 group-hover:text-[#D4AF37]" />
        </div>
        <div className="relative">
          <h3 className="font-display text-2xl leading-tight text-white sm:text-[28px]">{s.title}</h3>
          <p className="mt-2 line-clamp-2 text-sm text-slate-300">{s.text}</p>
        </div>
      </Link>
    </motion.div>
  );
};

export const ServicesBento = () => {
  const vedic = pick("vedic-astrology");
  return (
    <section data-testid="popular-services-section" className="relative px-5 py-24 sm:px-8 sm:py-32 lg:px-12">
      <div className="mx-auto max-w-[1400px]">
        <div className="flex flex-col gap-6 md:flex-row md:items-end md:justify-between">
          <Reveal>
            <Eyebrow>Popular Services</Eyebrow>
            <h2 className="font-display mt-5 max-w-2xl text-4xl leading-[1.02] text-white sm:text-5xl lg:text-6xl">
              Readings for every <span className="italic gold-text">crossroads</span>
            </h2>
          </Reveal>
          <Reveal delay={0.1}>
            <Link to="/services" data-testid="view-all-services-link" className="inline-flex items-center gap-2 border-b border-[#D4AF37]/40 pb-1 text-sm text-[#F3E5AB] hover:border-[#D4AF37]">
              View all 11 services <ArrowUpRight className="h-4 w-4" />
            </Link>
          </Reveal>
        </div>

        <div className="mt-14 grid gap-4 md:grid-cols-2 lg:grid-cols-3 lg:grid-rows-[repeat(3,minmax(240px,auto))]">
          <motion.div initial={{ opacity: 0, y: 30 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true, amount: 0.1 }}
            transition={{ duration: 0.9 }} className="md:col-span-2 lg:row-span-2">
            <Link to={`/book?service=${vedic.id}`} data-testid="bento-service-vedic-astrology"
              className="group relative flex h-full min-h-[420px] flex-col justify-end overflow-hidden border border-[#D4AF37]/25">
              <img src={vedic.image} alt="Vedic astrology birth chart artwork" loading="lazy"
                className="absolute inset-0 h-full w-full object-cover brightness-125 saturate-125 transition-transform duration-1000 ease-out group-hover:scale-105" />
              <div className="absolute inset-0 bg-gradient-to-t from-[#07040D]/95 via-[#07040D]/25 to-transparent" />
              <div className="absolute inset-0 bg-[radial-gradient(circle_at_30%_20%,rgba(212,175,55,0.22),transparent_45%)] opacity-70 transition-opacity duration-700 group-hover:opacity-100" />
              <div className="relative p-7 sm:p-10">
                <span className="font-cinzel text-xs tracking-[0.3em] text-[#F3E5AB]">SIGNATURE READING</span>
                <h3 className="font-display mt-3 text-4xl text-white sm:text-6xl">{vedic.title}</h3>
                <p className="mt-4 max-w-lg text-sm leading-relaxed text-slate-200 sm:text-base">{vedic.text}</p>
                <span className="mt-6 inline-flex items-center gap-2 rounded-full bg-[#D4AF37] px-5 py-2.5 text-sm font-medium text-[#07040D] transition-[gap] duration-300 group-hover:gap-3">
                  Book Now <ArrowUpRight className="h-4 w-4" />
                </span>
              </div>
            </Link>
          </motion.div>
          {SMALL.map((s, i) => (
            <Tile key={s.id} s={s} i={i} className={i === 4 ? "md:col-span-2 lg:col-span-1" : ""} />
          ))}
        </div>
      </div>
    </section>
  );
};
